<template>
  <div class="TupianClassify inner_center">
    TupianClassify
  </div>
</template>

<script>
export default {
  name: "TupianClassify"
}
</script>

<style scoped>

</style>
